export default "__VITE_ASSET__D8zsQSa4__"